module.exports = __webpack_public_path__ + "static/the-salmon-of-doubt-37a557272bac7da12e011eb765f7a929.jpg";